import React, { useRef } from 'react';
var VeltCommentsSidebarV2MinimalActionsDropdown = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-minimal-actions-dropdown-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2MinimalActionsDropdown;
